import { ReactNode } from 'react';
import { FiX } from 'react-icons/fi';

interface ThreeColumnLayoutProps {
    leftSidebar?: ReactNode;
    children: ReactNode;
    rightPanel?: ReactNode;
    showRightPanel?: boolean;
    onCloseRightPanel?: () => void;
    leftSidebarTitle?: string | ReactNode;
    // Largura da barra lateral de filtros. Default w-80 (mantém todas as telas existentes
    // inalteradas); telas com filtros de labels curtas podem passar uma classe menor.
    leftSidebarWidth?: string;
}

const ThreeColumnLayout = ({
    leftSidebar,
    children,
    rightPanel,
    showRightPanel = false,
    onCloseRightPanel,
    leftSidebarTitle = "Filtros",
    leftSidebarWidth = "w-80"
}: ThreeColumnLayoutProps) => {
    return (
        <div className="flex h-screen bg-gray-50 dark:bg-slate-800 overflow-hidden">
            {/* Left Sidebar - Filters */}
            <div className={`${leftSidebarWidth} bg-white dark:bg-slate-900 border-r border-gray-200 dark:border-slate-700 flex flex-col flex-shrink-0`}>
                <div className="flex items-center justify-between p-3 border-b border-gray-200 dark:border-slate-700">
                    {typeof leftSidebarTitle === 'string' ? (
                        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                            {leftSidebarTitle}
                        </h2>
                    ) : (
                        leftSidebarTitle
                    )}
                </div>
                <div className="flex-1 overflow-y-auto">
                    {leftSidebar}
                </div>
            </div>

            {/* Main Content */}
            <div className={`
                flex-1 flex flex-col min-w-0
                ${showRightPanel ? 'mr-8' : 'mr-8'}
                transition-all duration-300 ease-in-out
            `}>
                {children}
            </div>

            {/* Right Panel - Form/Details */}
            <div className={`
                ${showRightPanel ? 'w-[600px]' : 'w-8'}
                transition-all duration-300 ease-in-out
                bg-white dark:bg-slate-900
                border-l border-gray-300 dark:border-slate-600
                flex flex-col
                overflow-hidden
                fixed right-0 top-0 h-full z-20
                shadow-lg
                min-w-8
            `}>
                <div className={`flex-1 overflow-y-auto transition-opacity duration-300 ${showRightPanel ? 'opacity-100' : 'opacity-0'}`}>
                    {showRightPanel && rightPanel}
                </div>
            </div>

            {/* Floating Close Button */}
            <button
                onClick={onCloseRightPanel}
                className={`fixed top-[15px] right-[585px] w-8 h-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out z-[9999] flex items-center justify-center border border-gray-300 dark:border-slate-600 bg-gray-500 hover:bg-gray-600 text-white ${showRightPanel && onCloseRightPanel ? 'opacity-100 scale-100' : 'opacity-0 scale-75 pointer-events-none'
                    }`}
                title="Fechar"
            >
                <FiX size={14} />
            </button>

            {/* Overlay for mobile */}
            {showRightPanel && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-10 lg:hidden"
                    onClick={onCloseRightPanel}
                />
            )}
        </div>
    );
};

export default ThreeColumnLayout;
